import { useAnnouncements } from './useAnnouncements';
import { useBoundaries } from './useBoundaries';
import { useInteractionHandler } from './useInteractionHandler';
import { useInputSelectState } from './useInputSelectState';
import { focusOnInput } from '../utils';
import { a11y, visual } from '../../../strings';
export const useInputSelect = ({ variant, options, inputWrapperRef, inputValue, minSearchChars = 1, maxDisplayedOptions = 5, isLoading = false, getAriaLiveResults = a11y.getAriaLiveResults, noResultsText = visual.noResults, }) => {
    const { filteredOptions, showOptions, showLoading, setShowOptions, setShowLoading, isMounted, } = useInputSelectState({
        variant,
        options,
        inputWrapperRef,
        inputValue,
        minSearchChars,
        maxDisplayedOptions,
        isLoading,
    });
    const { boundaries } = useBoundaries({ inputWrapperRef });
    useAnnouncements({
        inputValue,
        minSearchChars,
        filteredOptions,
        showOptions,
        isLoading,
        getAriaLiveResults,
        noResultsText,
    });
    useInteractionHandler({
        inputWrapperRef,
        showLoading,
        showOptions,
        setShowLoading,
        setShowOptions,
    });
    return {
        filteredOptions,
        boundaries,
        showOptions,
        showLoading,
        setShowOptions,
        focusOnInput,
        isMounted,
    };
};
//# sourceMappingURL=useInputSelect.js.map